module.exports = __webpack_public_path__ + "static/media/reg5ru.93d45fea.pdf";